import React from 'react'

function BackArrow() {
	return (
		<svg width="30" height="30" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_d_1786_17562)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M17.2998 9.03477C17.2998 9.40756 16.9976 9.70977 16.6248 9.70977L7.05068 9.70977L10.7927 13.2732C11.0614 13.5316 11.0698 13.9589 10.8114 14.2276C10.553 14.4963 10.1257 14.5047 9.85696 14.2463L4.90696 9.52133C4.7746 9.39407 4.6998 9.21838 4.6998 9.03477C4.6998 8.85115 4.7746 8.67547 4.90696 8.5482L9.85696 3.8232C10.1257 3.56482 10.553 3.5732 10.8114 3.84192C11.0698 4.11064 11.0614 4.53794 10.7927 4.79633L7.05068 8.35977L16.6248 8.35977C16.9976 8.35977 17.2998 8.66197 17.2998 9.03477Z"
					fill="white"
				/>
			</g>
			<defs>
				<filter id="filter0_d_1786_17562" x="-2" y="0.0351562" width="26" height="26" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1786_17562" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1786_17562" result="shape" />
				</filter>
			</defs>
		</svg>
	)
}

export default BackArrow
